import React from 'react';
import { useTranslate } from '../../contexts/languageContext';

const TablaTerritorios_Cabecera = () => {
  const t = useTranslate();
  return (
    <div>
      <div style= {{display: 'flex', flexDirection: 'row', width: '100%'}}>
        <div style={{width: '20%', textAlign: 'center'}}>{t('territoriosMayuscula')}</div>
        <div style={{width: '40%', textAlign: 'center'}}>{t('partidoMasVotado')}</div>
        <div style={{width: '20%', textAlign: 'center'}}>{t('mesasInf')}</div>
        <div style={{width: '20%', textAlign: 'center'}}>{t('votantes')}</div>
      </div>
    </div>
  );
};

export default TablaTerritorios_Cabecera;
